import axios from 'axios'
import ServiceConfig from "./ServiceConfig";

const API_URL = ServiceConfig.API_URL;

class SFNService {

  getSFNUebersicht(jahr) {
    return axios.get(`${API_URL}/api/v1/sfn-uebersicht?jahr=${jahr}`);
  }

}

const sfnService = new SFNService();
export default sfnService;